/* eslint-disable no-labels */
 <template>
 <div v-role="'func'" style="margin-top:5px;">
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

     <div v-if="false">

           <v-card
    class="mx-auto"
    outlined
  >
  <div class="text-center">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Bloqueada</v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </div>

  </v-card>
     </div>
 <div v-if="true">
  <v-data-table
    :headers="headers"
    :items="coordenadores"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Cadastrar Coordenador

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
         <div class="flex-grow-1"></div>
         <v-row>
        <v-col class="text-center" cols="4" ><v-btn style="margin-top:15px;" x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span class="headline">Cadastrar Coordenador </span>
               <v-progress-circular
                    v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                       <v-select
                       v-model="editedItem.idProfessor"
                        :items="professores"
                        item-text="nome"
                        item-value="idProfessor"
                        label="Selecione o professor"
                        return-object
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                      v-model="editedItem.idCurso"
                        :items="cursos"
                        item-text="descricao"
                        item-value="idCurso"
                        label="Selecione o Curso"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>

              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid) || editedItem.idProfessor === '' || editedItem.idCurso ===''
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    text: '',
    flag_curso: '',
    formValid: true,
    coordenadores: [],
    coordenadores_verificacao: [],
    progresso: false,
    professores: [],
    mascara: '#########-AA-###',
    usuarios: [],
    isLoading: false,
    search: '',
    descricao: 'Bilhete',
    cursos: [],
    usuariosJaExistentes: [],
    obrigqtorioRules: [
      value => !!value || 'campo obrigatório.'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],

    funcionarios: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Curso', value: 'curso' },
      { text: 'AnoLectivo', value: 'anolectivo' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idProfessor: '',
      idCurso: ''
    },
    defaultItem: {
      idFuncionario: '',
      idPEssoa: '', // bi
      i_id: '', // idinstituicao
      email: '',
      nome: '',
      telefone: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Funcionário' : 'Editar'
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    anolectivo () {
      return ls.get('anolectivo')
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    // this.initialize()
    this.iniprofessores()
    this.initializeCursos()
    this.iniCoordenadores()
  },

  methods: {

    async CarregaUsuarios (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }

        this.usuarios = await axios
          .get('/usuarioFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async iniCoordenadores (search) {
      try {
        this.isLoading = true

        this.coordenadores_verificacao = await axios
          .get('/ListarCoordenadores')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initialize (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }

        this.funcionarios = await axios
          .get('/funcionarioFindAll/' + payload)
          .then(res => res.data).then(this.CarregaUsuarios())

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.funcionarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.funcionarios.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
      this.funcionarios.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    outroDoc () {
      if (this.descricao === 'Bilhete') {
        this.editedItem.idPEssoa = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
               [
                 value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
               ]
      } else {
        this.editedItem.idPEssoa = ''
        this.descricao = 'Bilhete'
        this.mascara = '#########-AA-###'
        // eslint-disable-next-line no-labels
        ruleBI:
        // eslint-disable-next-line no-unused-expressions
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
        ]
      }
    },

    async iniprofessores (search) {
      try {
        this.isLoading = true
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async save () {
      //  this.progresso = true

      // console.log(this.coordenadores_verificacao);
      this.progresso = true
      try {
        var params =
            {
              idProfessor: this.editedItem.idProfessor.idProfessor,
              idCurso: this.editedItem.idCurso,
              idPessoa: this.editedItem.idProfessor.idPessoa
            }

        var params_tabela = {

          nome: this.professores.filter(p => p.idProfessor === params.idProfessor)[0].nome,
          curso: this.cursos.filter(c => c.idCurso === params.idCurso)[0].descricao,
          anolectivo: ls.get('anolectivo')
        }
      } catch (err) { }

      let v = this.coordenadores_verificacao.filter(p => p.idProfessor === this.editedItem.idProfessor && p.idCurso === this.editedItem.idCurso)

      if (!v.length) {
        let cor_mensagem = 'msgError'
        try {
          let msg = await axios
            .post('/coordenadordisciInsertOrUpdate', params)
            .then(res => res.data)
          // verificação da mensagem
          if (msg.length) {
            let erro = msg[0]
            this.text = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
            cor_mensagem = 'msgError'
            this.progresso = false
          } else {
            this.text = 'Operação efectuada com sucesso.'
            this.coordenadores.unshift(params_tabela) // Adiciona o objecto a coleção
            cor_mensagem = 'msgSucess'
            this.progresso = false
            this.close()
          }
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: cor_mensagem,
            timeout: 4000
          })
        } catch (error) {
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: cor_mensagem,
            timeout: 4000
          })
        }
      } else {
        this.text = 'Este curso ja tem um coordenador cadastrado'
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 4000
        })
      }

      this.progresso = false
    }
  }

}
</script>
